module.exports = __webpack_public_path__ + "static/media/Spectre.e512d972.jpg";